export interface BatchProgressEventData {
  batchId: string
  spaceId?: string
  serviceId?: string
  progress: number
  status: string
  completedCount?: number
  totalCount?: number
  failedCount?: number
  message?: string
}

export interface BatchStatusEventData {
  batchId: string
  spaceId?: string
  serviceId?: string
  status: 'pending' | 'running' | 'completed' | 'failed' | 'partially_succeeded' | 'cancelled'
  startedAt?: Date
  completedAt?: Date
  error?: string
}

export interface AnalysisEventData {
  analysisId: string
  questionId: string
  spaceId?: string
  serviceId?: string
  batchId?: string
  status: string
  score?: {
    priorityScore?: number
    positiveScore?: number
    citationScore?: number
    characterCountScore?: number
  }
}

export interface ScheduledAnalysisRetryEventData {
  scheduledAnalysisId: string
  executionId: string
  spaceId?: string
  serviceId?: string
  status: 'retrying' | 'completed' | 'failed'
  progress?: number
  message?: string
  failedCount?: number
  successCount?: number
  totalCount?: number
  error?: string
}

export enum WebSocketEvents {
  // Connection events
  CONNECTION = 'connection',
  DISCONNECT = 'disconnect',
  ERROR = 'error',

  // Authentication events
  AUTH_SUCCESS = 'auth:success',
  AUTH_FAILED = 'auth:failed',

  // Batch events
  BATCH_STARTED = 'batch:started',
  BATCH_PROGRESS = 'batch:progress',
  BATCH_COMPLETED = 'batch:completed',
  BATCH_FAILED = 'batch:failed',

  // Analysis events
  ANALYSIS_CREATED = 'analysis:created',
  ANALYSIS_UPDATED = 'analysis:updated',
  ANALYSIS_COMPLETED = 'analysis:completed',

  // Scheduled analysis retry events
  SCHEDULED_ANALYSIS_RETRY_STARTED = 'scheduled_analysis:retry_started',
  SCHEDULED_ANALYSIS_RETRY_PROGRESS = 'scheduled_analysis:retry_progress',
  SCHEDULED_ANALYSIS_RETRY_COMPLETED = 'scheduled_analysis:retry_completed',
  SCHEDULED_ANALYSIS_RETRY_FAILED = 'scheduled_analysis:retry_failed',

  // Room events
  JOIN_SPACE = 'join:space',
  LEAVE_SPACE = 'leave:space',
  JOIN_BATCH = 'join:batch',
  LEAVE_BATCH = 'leave:batch',
}

export interface WebSocketConnectionState {
  isConnected: boolean
  isConnecting: boolean
  error: Error | null
}
